import { TableSpec } from "alurkerja-ui/dist/types";

interface CustomFieldOptions {
  [key: string]: unknown;
  name: string;
  label: string;
  filterable?: boolean;
  sortable?: boolean;
  prefix?: string;
  suffix?: string;
  select_options?: {
    options?: { label: string; key: string }[];
  };
}
interface CustomSpecOptions {
  canBulk?: boolean;
  path: string;
  fields?: CustomFieldOptions[];
  canEdit?: boolean;
}
export function generateCustomSpec({
  canBulk,
  path,
  fields = [],
  canEdit = true,
}: CustomSpecOptions) {
  const defaultFieldOptions = {
    name: "",
    label: "",
    required: true,
    searchable: true,
    filterable: false,
    sortable: true,
    type: "text",
    form_field_type: "INPUT_TEXT",
    primary: false,
    is_hidden_in_list: false,
    is_hidden_in_create: false,
    is_hidden_in_edit: false,
    is_hidden_in_detail: false,
    rules: [""],
    format: "",
    prefix: "",
    suffix: "",
    list_order: 1,
    create_order: 1,
    edit_order: 1,
  };

  const fieldsWithNumber: { [key: string]: unknown } = fields?.reduce(
    (acc, field) => {
      return {
        ...acc,
        [field.name]: {
          ...defaultFieldOptions,
          ...field,
          list_order: fields.indexOf(field) + 1,
          sortName: field.sortName || field.name,
        },
      };
    },
    {},
  );
  fieldsWithNumber.custom_no = {
    ...defaultFieldOptions,
    name: "custom_no",
    label: "No",
    list_order: 0,
    sortable: false,
    searchable: false,
  };

  const spec = {
    show_as_menu: true,
    base_url: window.location.origin,
    label: "List",
    name: "list",
    is_bpmn: false,
    is_usertask: false,
    can_bulk: canBulk ?? true,
    can_create: true,
    can_delete: false,
    can_edit: canEdit,
    can_detail: true,
    path: path,
    description: "",
    header_action: [],
    field_action: [
      {
        label: "Detail",
        action_label: "Detail",
        method: "get",
        form_type: "modal",
        path: `${path}/{id}`,
        icon: "eye",
        type: "primary",
      },
      {
        label: "Edit",
        action_label: "Edit",
        method: "put",
        form_type: "modal",
        path: `${path}/{id}`,
        icon: "edit",
        type: "primary",
      },
      {
        label: "Delete",
        action_label: "Delete",
        method: "delete",
        form_type: "confirm_modal",
        confirm: {
          title: "Alert",
          message:
            "This action cannot be undone. Are you sure you want to proceed and delete the data?",
          confirm_text: "Yes",
          cancel_text: "No",
        },
        path: `${path}/{id}`,
        icon: "trash",
        type: "danger",
      },
    ],
    languages: {
      pagination_info: "Page limit",
      empty_data: "No data",
    },
    fields: fieldsWithNumber,
  };

  return spec as TableSpec;
}
